// В.2.d-3: Переливание крови (liv_perelivanie_krovi, rare Действие).
// «Забери 3 ХП у своего Героя и передай их союзному юниту в виде Атаки и
//  Здоровья».
//
// Picker: только СВОИ юниты на поле. Если своих нет — Действие сгорает.
// (Цель — только юнит, не Герой. Цель не может быть атакована Иммунитетом —
//  это передача от своего Героя своему юниту, не атака.)
//
// Эффект:
//   - Забрать у Героя `min(3, hero.hp)` ХП через applyHeroDamage. Этот
//     путь триггерит Тёмного нетраннера (как любой урон по Герою) — это
//     намеренно: «персонаж получил урон» сработает.
//   - Юнит получает +N/0/N через applyPermanentBuff, где N — фактически
//     отданный объём (равен hpLost после удара).
//   - Если у Героя 0 ХП до карты — карта по логике сгорает (нечего отдавать;
//     но это вырожденный случай — матч уже кончен).
//
// Лог: «🩸 Переливание крови: Герой [сторона] -N ХП → имя_цели +N/0/N».

import { applyHeroDamage } from '../../hero-damage.js';
import { applyPermanentBuff } from '../../buffs.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_perelivanie_krovi';
const LABEL = 'Переливание крови';
const TRANSFER = 3;

registerImplementedAbility(CARD_ID, 'oneshot');

export function actionTargets(state, playerIdx) {
  const me = state.players?.[playerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u => u.type === 'unit');
}

export function resolve(state, playerIdx, target /*, opts */) {
  const me = state.players?.[playerIdx];
  const ownUnits = me ? me.unitsOnField().filter(u => u.type === 'unit') : [];
  if (ownUnits.length === 0) {
    state.log?.add(`🩸 ${LABEL}: нет цели — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  if (!target || !target.isAlive || !target.isAlive() ||
      target.type !== 'unit' || target.ownerId !== playerIdx) {
    state.log?.add(`🩸 ${LABEL}: цель недоступна — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  if (!me?.hero || me.hero.hp <= 0) {
    state.log?.add(`🩸 ${LABEL}: Герой пал — Действие сгорает`);
    return { ok: true, skipped: true };
  }

  const wantedDmg = Math.min(TRANSFER, me.hero.hp);
  const r = applyHeroDamage(state, playerIdx, wantedDmg, { sourceLabel: LABEL });
  // Фактический объём — сколько ХП Герой потерял (parachute / immune обнуляют).
  const actualLoss = (r.hpLost || 0) + (r.armorAbsorbed || 0);
  if (actualLoss <= 0) {
    state.log?.add(`🩸 ${LABEL}: Герой [${me.name}] не отдал ХП (Иммунитет/Парашют) — буффа нет`);
    return { ok: true, skipped: true };
  }
  applyPermanentBuff(state, target, { atk: actualLoss, armor: 0, hp: actualLoss }, CARD_ID, LABEL);
  state.log?.add(
    `🩸 ${LABEL}: Герой [${me.name}] -${actualLoss} ХП → ${target.name_ru} +${actualLoss}/0/${actualLoss}`
  );
  return { ok: true };
}
